import { parseUtmFromUrl, type ForceVariantEnv } from '../enrollment-shared';
import { getResolvedExperimentEnrollments } from './persist';

/**
 * Builds the env passed to a client-side `forceVariant` predicate from
 * browser globals. Caller is responsible for sourcing `isEmbeddedWebView`
 * (it depends on a React hook). URL, UTM, and referer are read directly
 * from `window`/`document` so this util must only be invoked client-side.
 *
 * `referer` is normalized: `document.referrer` returns an empty string
 * when no referrer is available, which we surface as `null` so predicates
 * only have to check one absent state.
 *
 * `existingEnrollments` is a read-only snapshot of the visitor's settled
 * enrollments from the same cookie the enrollment system already uses, so a
 * `forceVariant` predicate can gate on cross-experiment state.
 */
export function buildClientForceVariantEnv({
  isEmbeddedWebView,
}: {
  isEmbeddedWebView: boolean;
}): ForceVariantEnv {
  const url = new URL(window.location.href);
  const referer = document.referrer === '' ? null : document.referrer;
  return {
    isEmbeddedWebView,
    url,
    utm: parseUtmFromUrl(url),
    referer,
    existingEnrollments: getResolvedExperimentEnrollments(),
  };
}
